// Ajax cart JS for Drawer and Cart Page
const drawerSelectors = {
    cartIcons: document.querySelectorAll('.header__icon--cart'),
    cartIconDesktop: document.querySelector('#cart-icon-desktop'),
    cartIconMobile: document.querySelector('#cart-icon-mobile'),
};
class ajaxCart extends HTMLElement {
    constructor() {
        super();

        this.openeBy = drawerSelectors.cartIcons;
        this.isOpen = this.classList.contains('open--drawer');
        this.bindEvents();

        if (window.globalVariables.template != 'cart') {
            this.addAccessibilityAttributes(this.openeBy);
            this.getCartData();
        } else {
            this.style.visibility = 'visible';
        }
        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    /**
     * Observe attribute of component
     * 
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
        return ['updating'];
    }

    /**
     * To Perform operation when attribute is changed
     * Calls attributeChangedCallback() with params when attribute value is updated
     * 
     * @param {string} name attribute name
     * @param {string} oldValue attribute Old value
     * @param {string} newValue attribute latest value
     */
    attributeChangedCallback(name, oldValue, newValue) {
        // called when one of attributes listed above is modified
        if (name == 'updating' && newValue == 'false') {
            this.updateEvents();
        }
    }

    /**
     * Add accessibility attributes to Open Drawer buttons
     * 
     * @param {Node Array} openDrawerButtons Cart Icons
     */
    addAccessibilityAttributes(openDrawerButtons) {
        let _this = this;
        openDrawerButtons.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', _this.id);
        });
    }

    /**
     * Escape Click event to close drawer when focused within Cart Drawer
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }

    /**
     * bind dclick and keyup event to Cart Icons
     * bind keyUp event to Cart drawer component
     * bind Other inside element events
     *
     */
    bindEvents() {
        if (window.globalVariables.template != 'cart') {
            this.openeBy.forEach(cartBtn => cartBtn.addEventListener('click', this.openCartDrawer.bind(this)));
            this.addEventListener('keyup', this.onKeyUp.bind(this));
        }
        this.updateEvents();
    }

    /**
     * bind Other inside element events to DOM
     *
     */
    updateEvents() {
        this.querySelectorAll('.close-ajax--cart').forEach(button => button.addEventListener('click', this.closeCartDrawer.bind(this)));
        this.querySelectorAll('[data-itemRemove]').forEach(button => button.addEventListener('click', this.removItem.bind(this)));
        this.querySelectorAll('[data-qty-btn]').forEach(button => button.addEventListener('click', this.manageQtyBtn.bind(this)));
        this.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('click', this.onQtyChange.bind(this)));
        this.querySelectorAll('[change-upsell-collection-product-variant]').forEach(button => button.addEventListener('change', this.changeUpsellProductVariant.bind(this)));
        this.querySelectorAll('[add-upsell-collection-product]').forEach(button => button.addEventListener('click', this.addUpsellProductVariant.bind(this)));
        this.querySelectorAll('[data-submitCartForm]').forEach(button => button.addEventListener('click', this.submitCartForm.bind(this)));
    }

    /**
     * Open Cart drawer and add focus to drawer container
     *
     * @param {event} Event instance
     */
    openCartDrawer(event) {
        if (!window.globalVariables.cart_drawer) {
            window.location.href = window.routes.cart_fetch_url || '/cart';
            return;
        }

        if (document.querySelector('#mobile-menu-drawer').classList.contains('opened-drawer')) {
            document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
        }

        this.classList.add('opened-drawer');
        siteOverlay.prototype.showOverlay();
        Utility.forceFocus(this.querySelector('.cart-title'));
        let closeBtn = this.querySelector('.close-ajax--cart');
        Utility.trapFocus(this, closeBtn);

        if (event) {
            event.preventDefault();
            let openBy = event.currentTarget;
            openBy.setAttribute('aria-expanded', true);
        }
    }

    /**
     * Close Cart drawer and Remove focus from drawer container
     *
     * @param {event} Event instance
     */
    closeCartDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            event.preventDefault();
            this.classList.remove('opened-drawer');
            siteOverlay.prototype.hideOverlay();
            let openByEle = event.currentTarget;
            openByEle.setAttribute('aria-expanded', false);
            Utility.removeTrapFocus(elementToFocus);

            let actionBtn = drawerSelectors.cartIconDesktop;
            if (window.innerWidth < 1024) {
                actionBtn = drawerSelectors.cartIconMobile;
            }
            Utility.forceFocus(actionBtn);
        }
    }

    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {string} action Open Drawer as value if need to Open Cart drawer
     */
    _updateCart(response, action) {
        this.setAttribute('updating', true);

        // Convert the HTML string into a document object
        let cartHTML = '';
        if (window.globalVariables.template != 'cart') {
            cartHTML = response['template-ajax-cart'];
        } else {
            cartHTML = response['template-cart'];
        }

        if (cartHTML == null) return;
        let parser = new DOMParser();
        cartHTML = parser.parseFromString(cartHTML, 'text/html');

        // let cartElement = cartHTML.querySelector('ajax-cart');
        // this.innerHTML = cartElement.innerHTML;

        let cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
        if (cartJSONEle != undefined && cartJSONEle != null) {
            window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);
        }

        let cartElement = cartHTML.querySelector('ajax-cart form');
        this.querySelector('form').innerHTML = cartElement.innerHTML;
      
      	if (window.globalVariables.template == 'cart') {
            let cartPageUpsell = cartHTML.querySelector('ajax-cart [data-cart-page-upsell]');
            this.querySelector('[data-cart-page-upsell]').innerHTML = cartPageUpsell.innerHTML;
        }

        this.querySelector('[data-carttotal] span.money').innerHTML = Shopify.formatMoney(window.globalVariables.cart.total_price, window.globalVariables.money_format);
        if (window.globalVariables.template != 'cart') {
            this.querySelector('[data-cartCount]').innerHTML = window.globalVariables.cart.item_count;
        }
        let elements = this.querySelectorAll('[data-checkoutBtns]');
        if (window.globalVariables.cart.item_count <= 0) {
            elements.forEach((div) => {
                div.classList.add('d-none');
            });
        } else {
            elements.forEach((div) => {
                div.classList.remove('d-none');
            });
        }
        this.setAttribute('updating', false);

        let headerHTML = new DOMParser().parseFromString(response['header'], 'text/html');
        let cartIcon = headerHTML.getElementById('cart-icon-desktop');
        if (drawerSelectors.cartIconDesktop) drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
        if (drawerSelectors.cartIconMobile) drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;

        if (window.globalVariables.cart_drawer == true && action == 'open_drawer' && window.globalVariables.template != 'cart') {
            this.openCartDrawer();
        }
    }

    /**
     * Fetch latest cart data 
     *
     * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
     */
    getCartData(action) {
        let fetchCart = fetch(`${routes.cart_fetch_url}?sections=template-cart,header`);
        if (window.globalVariables.template != 'cart') fetchCart = fetch(`${routes.cart_fetch_url}?sections=template-ajax-cart,header`);
        fetchCart.then(response => {
            return response.json();
        }).then(response => {
            this._updateCart(response, action);
        }).catch((e) => {
            console.error(e);
        }).finally(() => {
            // Cart HTML fetch done
        });
    }

    /**
     * Update Quantity API call 
     *
     * @param {string} line Line Index value of cart Item (Starts from 1)
     * @param {integer} quantity Quantity to update
     */
    updateItemQty(line, quantity) {
        let lineItem = document.querySelectorAll('[data-cart-item]')[line - 1];

        if (lineItem) { lineItem.classList.add('updating'); }
        const body = JSON.stringify({
            line,
            quantity
        });

        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ... { body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                this.getCartData();
                setTimeout(() => {
                    if (lineItem) { lineItem.classList.remove('updating'); }
                }, 1000);
            }).catch((error) => {
                setTimeout(() => {
                    if (lineItem) { lineItem.classList.remove('updating'); }
                }, 1000);
                console.log(error);
            });
    }

    /**
     * Remove Item Event
     *
     * @param {event} Event instance
     */
    removItem(event) {
        event.preventDefault();
        let currentTarget = event.currentTarget;
        let itemIndex = currentTarget.dataset.index || null;
        if (itemIndex != null) {
            this.updateItemQty(itemIndex, 0);
        }
    }

    /**
     * Cart Item Qunatity Increment/Decrement Button event
     *
     * @param {event} Event instance
     */
    manageQtyBtn(event) {
        event.preventDefault();
        let currentTarget = event.currentTarget;
        let action = currentTarget.dataset.for || 'increase';
        let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
        let itemIndex = $qtyInput.dataset.index || 1;
        let currentQty = parseInt($qtyInput.value) || 1;
        let finalQty = 1;

        if (action == 'decrease' && currentQty <= 1) {
            return false;
        } else if (action == 'decrease') {
            finalQty = currentQty - 1;
        } else {
            finalQty = currentQty + 1;
        }
        this.updateItemQty(itemIndex, finalQty);
    }

    /**
     * Cart Item Qunatity Input change event
     *
     * @param {event} Event instance
     */
    onQtyChange(event) {
        const $qtyInput = event.currentTarget;
        const qtyValue = $qtyInput.value;
        const itemIndex = $qtyInput.dataset.index || null;
        if (itemIndex) this.updateItemQty(itemIndex, qtyValue);
    }

    changeUpsellProductVariant(event) {
        let currentTarget = event.currentTarget;
        let productVariantDataValue = currentTarget.value;

        var productVariantData = productVariantDataValue.split(",");
        var productVariantId = productVariantData[0];
        var productVariantPrice = productVariantData[1];
        var productVariantPriceINR = Shopify.formatMoney(productVariantPrice, window.globalVariables.money_format);

        currentTarget.closest('[grid-upsell-collection-product]').querySelector('[upsell-product-variant-price]').innerHTML = productVariantPriceINR;
        currentTarget.closest('[grid-upsell-collection-product]').querySelector('[data-upsellproductvariantid]').dataset['upsellproductvariantid'] = productVariantId;
    }

    addUpsellProductVariant(event) {
        let currentTarget = event.currentTarget;
        let upsellProductVariantId = currentTarget.getAttribute("data-upsellProductVariantId") || null;
//         console.log('variant-id', currentTarget);

        currentTarget.closest('[grid-upsell-collection-product]').style.pointerEvents = "none";
        currentTarget.closest('[grid-upsell-collection-product]').style.opacity = "0.6";

        const result = fetch("/cart/add.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                id: parseInt(upsellProductVariantId),
                quantity: 1
            })
        }).then(response => {
            document.querySelector('ajax-cart').getCartData();
        })
    }

    submitCartForm() {
        document.getElementById("submitCartForm").submit();
    }
}
customElements.define("ajax-cart", ajaxCart);